export const BRIDGE_CACHE_TIMEOUT = 60 * 60 * 1000; // 1 hour
